import { render, staticRenderFns } from "./TaskWorkflowPermanentlyDeleted.vue?vue&type=template&id=00013128&scoped=true"
import script from "./TaskWorkflowPermanentlyDeleted.vue?vue&type=script&lang=js"
export * from "./TaskWorkflowPermanentlyDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00013128",
  null
  
)

export default component.exports